import { CHECK } from 'common/constants';
import { apiService } from '../apiService';
import { METHOD, PATHS } from '../constants';
import { validateCompanyAndStore } from '../utils';
import type { HeaderData } from 'adapters/types';
import type { PrintChecksResponse } from 'pages/VendorsTablePage/components/PrintChecks/types';
import type { VendorsResponseDataType } from 'pages/VendorsTablePage/components/VendorsTable/types';

export const fetchVendors = async (
  headers: HeaderData,
  companyId: string,
  storeId: string,
  dueDate?: string,
  paymentMethod?: string,
  isApproved?: boolean,
  isAuthorized?: boolean
): Promise<VendorsResponseDataType> => {
  const qsObject = {
    dueDate: dueDate || undefined,
    paymentMethod: !paymentMethod && isApproved ? CHECK : paymentMethod,
    isApproved: isApproved ?? undefined,
    isAuthorized: isAuthorized ?? undefined
  };
  validateCompanyAndStore(companyId, storeId);
  const response = await apiService({
    url: PATHS.getVendorsPath(companyId),
    method: METHOD.GET,
    headers: { ...headers, 'x-store-id': storeId },
    qsObject
  });
  if (response.ok)
    return (await response.json()) as Promise<VendorsResponseDataType>;
  throw new Error(response.statusText);
};

export const fetchPrintAuthorizedVendors = async (
  headers: HeaderData,
  companyId: string,
  storeId: string
): Promise<PrintChecksResponse> => {
  validateCompanyAndStore(companyId, storeId);
  const response = await apiService({
    url: `${PATHS.getVendorsServicePath(companyId)}/print-authorized`,
    method: METHOD.GET,
    headers: { ...headers, 'x-store-id': storeId }
  });
  if (response.ok)
    return (await response.json()) as Promise<PrintChecksResponse>;
  throw new Error(response.statusText);
};
